// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"693":"controls","890":"visuals"}[chunkId] + "." + {"693":"f467845f7230e588a3d7","890":"5a64b0c5b552fd8f8a60"}[chunkId] + ".chunk.bundle.js";
};